import AppsApi from '@/api/apps-api/apps-api.service';
import { mapGetters, mapActions } from 'vuex';
import Alerts from '@/components/alert-notifications/alert-notifications.vue';

export default {
  data() {
    return {
      appName: '',
    };
  },

  components: {
    Alerts,
  },

  computed: {
    ...mapGetters(['alert']),
  },

  watch: {
    appName() {
      if (this.alert) {
        this.ALERT_HIDE();
      }
    },
  },

  methods: {
    ...mapActions(['ALERT_DISPLAY', 'ALERT_HIDE']),

    handleOk(evt) {
      evt.preventDefault();

      if (!this.appName) {
        this.ALERT_DISPLAY('App name is required');

        return;
      }

      this.createApp();

      this.$refs.createAppModal.hide();
    },

    onHidden() {
      this.appName = '';
      this.ALERT_HIDE();
    },

    async createApp() {
      const app = await AppsApi.createApp({ name: this.formatAppName(this.appName), description: '' });
      this.$store.commit('ADD_APP', app);
    },

    formatAppName(appName) {
      return appName.split(' ').join('_');
    },
  },
  name: 'CreateApp',
};
